import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '@core/services/seo/meta-tag-service';
import { select, Store } from '@ngrx/store';
import { ContentfulService } from '@core/services/cms/contentful.service';

import * as fromCatalog from '@core/state/catalog/catalog.selectors';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-catalog-home',
  templateUrl: './catalog-home.component.html',
  styleUrls: ['./catalog-home.component.scss']
})
export class CatalogHomeComponent implements OnInit {
  allHeroEntries = {};
  search: any;
  query: any;
  hero: any;
  subcategory: any;
  popularCategoriesHome: any;
  designToolProducts: any;
  popularProductsHome: any;
  productSectionName: any;
  designSectionName: any;
  designToolBanner: any;
  designToolBannerMobile: any;
  shopTheCatalog: any;
  shopTheCatalogMobile: any;
  topBrands: any;
  screenWidth: any;
  featuredCollections: any;
  products: any;
  carouselHeader: any;
  categoryGallery: any;
  keyFeatures: any;
  callToAction: any;
  faqs: any;

  constructor(
    private contentfulService: ContentfulService,
    private store: Store,
    private metaService: MetaService,
    private router: Router

  ) {
    this.store.pipe(select(fromCatalog.selectCatalogCategories)).subscribe((popularCategoriesHome => { this.popularCategoriesHome = popularCategoriesHome }));
    this.store.pipe(select(fromCatalog.selectCatalogContentfulDesignToolProducts)).subscribe((designToolProducts => { this.designToolProducts = designToolProducts?.map(p => {
      const copy = {...p}
      copy.url = this.getProductUrl(p.url)
      return copy
    }) }));
    this.store.pipe(select(fromCatalog.selectCatalogContentfulProducts)).subscribe((popularProductsHome => { this.popularProductsHome = popularProductsHome }));
    this.store.pipe(select(fromCatalog.selectCatalogFeaturedCollections)).subscribe((featuredCollections => { this.featuredCollections = featuredCollections }));
    this.store.pipe(select(fromCatalog.selectCatalogBrands)).subscribe((topBrands => { this.topBrands = topBrands }));
    this.store.pipe(select(fromCatalog.selectProductsSectionName())).subscribe((productSectionName => { this.productSectionName = productSectionName }));
    this.store.pipe(select(fromCatalog.selectDesignSectionName())).subscribe((designSectionName => { this.designSectionName = designSectionName }));
    this.store.pipe(select(fromCatalog.selectContentfulBannerByName("Design Tool Banner"))).subscribe((designToolBanner => { this.designToolBanner = designToolBanner }));
    this.store.pipe(select(fromCatalog.selectContentfulBannerByName("Mobile - Design Tool Banner"))).subscribe((designToolBannerMobile => { this.designToolBannerMobile = designToolBannerMobile }));
    this.store.pipe(select(fromCatalog.selectContentfulBannerByName("Shop The Catalog"))).subscribe((shopTheCatalog => { this.shopTheCatalog = shopTheCatalog }));
    this.store.pipe(select(fromCatalog.selectContentfulBannerByName("Mobile - Shop The Catalog"))).subscribe((shopTheCatalogMobile => { this.shopTheCatalogMobile = shopTheCatalogMobile }));
    this.store.pipe(select(fromCatalog.selectProducts)).subscribe((products => { 
      this.products = products
    }));

    // 2025 Homepage
    this.store.pipe(select(fromCatalog.selectCarouselHeader)).subscribe((carouselHeader => { this.carouselHeader = carouselHeader
    }));

    this.store.pipe(select(fromCatalog.selectCategoryGallery)).subscribe((categoryGallery => { this.categoryGallery = categoryGallery
    }));

    this.store.pipe(select(fromCatalog.selectKeyFeatures)).subscribe((keyFeatures => { this.keyFeatures = keyFeatures
    }));

    this.store.pipe(select(fromCatalog.selectCallToAction)).subscribe((callToAction => { this.callToAction = callToAction
    }));

    this.store.pipe(select(fromCatalog.selectFAQ)).subscribe((faqs => { this.faqs = faqs
    }));
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;

    this.metaService.updateMetaTags(
      `Catalog`,
      `Explore Culture Studio's online catalog with tees, hats, outerwear, and more available for custom screen printing and embroidery. Leading wholesale brands, bulk orders, and blank customizable apparel for your brand.`,
      `Explore Culture Studio's online catalog with tees, hats, outerwear, and more available for custom screen printing and embroidery. Leading wholesale brands, bulk orders, and blank customizable apparel for your brand.`,
      `https://img.stokkup.com/app/cs-circle-logo.png`,
    )

    this.contentfulService.getHeroEntries()
    .then((response) => {
        response.forEach((category) => {
          this.allHeroEntries[category.fields.heroCategoryName] = category.sys.id;
        });

        if(Boolean(this.search)) {
          for (const [key, value] of Object.entries(this.allHeroEntries)) {
            if(key.toLowerCase() == this.search.toLowerCase()) {
              this.store.pipe(select(fromCatalog.selectHero(key))).subscribe((hero => { this.hero = hero }));
            }
          }
        } else if(Boolean(this.query)) {
          for (const [key, value] of Object.entries(this.allHeroEntries)) {
            if(key.toLowerCase() == this.query.toLowerCase()) {
              this.store.pipe(select(fromCatalog.selectHero(key))).subscribe((hero => { this.hero = hero }));
            }
          }
        } else {
          this.store.pipe(select(fromCatalog.selectHero('home'))).subscribe((hero => { this.hero = hero }));

        }
    });
  }

  scrollRight(container, section) {
    const distance = section == 'overflowFeaturedCollections' ? 500 : 350
    this.animateScroll(container, distance);
  }

  scrollLeft(container, section) {
    const distance = section == 'overflowFeaturedCollections' ? -500 : -350
    this.animateScroll(container, distance);
  }

  animateScroll(container, distance) {
    const start = container.scrollLeft;
    const duration = 500; // in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easedProgress = this.easeInOutQuad(progress);
      container.scrollLeft = start + (distance * easedProgress);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    console.log('container', container, 'distance', distance)
    requestAnimationFrame(animate);
  }

  easeInOutQuad(progress) {
    progress /= 0.5;
    if (progress < 1) {
      return 0.5 * progress * progress;
    }
    progress--;
    return -0.5 * (progress * (progress - 2) - 1);
  }

  getProductUrl(url) {
    return environment.production ? url : url.replace('https://cp.culturestudio.net/', 'http://localhost:4200/')
  }

  navigateToCatalog() {
    this.router.navigateByUrl(`/catalog/all?categories=design tool`);
}

  redirectTo(url: string) {
    // For internal routes
    if (url.startsWith('/')) {
      this.router.navigate([url]);
    } 
    // For external URLs
    else {
      window.location.href = url;
      // OR
      // window.open(url, '_blank'); // Opens in new tab
    }
  }

  // In your component
  openHubspotChat() {
    if (window['HubSpotConversations']) {
      window['HubSpotConversations'].widget.open();
    }
  }


}
